<template>
  <!-- 
  <form action="https://sis-t.redsys.es:25443/sis/realizarPago" method="post" ref="redsysForm">
  -->
  <form action="https://sis.redsys.es/sis/realizarPago" method="post" ref="redsysForm">
    <input type="hidden" name="Ds_MerchantParameters" :value="paymentData.Ds_MerchantParameters" />
    <input type="hidden" name="Ds_Signature" :value="paymentData.Ds_Signature" />
    <input type="hidden" name="Ds_SignatureVersion" :value="paymentData.Ds_SignatureVersion" />
  </form>
</template>
<script>
export default {
  name: "PaymentForm",
  props: {
    paymentData: { required: true },
  },
  mounted() {
    if (this.paymentData) {
      this.$store.commit("isLoading", true);
      this.$refs.redsysForm.submit();
    }
  },
};
</script>

